<template>
  <div id="codificator-builder-new-or-edit" class="wrapper-content w-100">
    <LmComponentLoading v-if="loading" fixed />
    <h1>Tipos de documento</h1>
    <LmForm ref="lmFormRef" id="documentTypes-header">
      <!-- <portal-target name="destination-after-title" slim/> -->
      <LmTextInput
        class="col-12 px-0"
        :v="$v.formData.typeName"
        v-model="formData.typeName"
        label="Nombre del tipo de documento"
        placeholder="Nombre"
      />
      <LmSuperPowerSelectV2
        :options="documentTypesOptionsForDuplicate"
        @input="loadFormElements"
        label="Cargar campos desde otro tipo de documento"
      />
    </LmForm>
    <LmUserPermissions
      className="col-6 px-0"
      :form="form"
    />
      <!-- FormBuilderUi -->
      <div id="lm-form-builder-ui" class="wrapper-content w-100 pl-0 mt-3">
      <h3>Campos del documento</h3>
      <div class="row position-relative">
        <div class="col-12 mt-3">
          <b-form-group>
            <b-form-radio-group
              id="btn-modos"
              v-model="modes.selected"
              :options="modes.options"
              buttons
              button-variant="primary"
              @change="modes.editView = $event === 'edit'"
            />
          </b-form-group>
        </div>
        <div class="col-12 col-md-6 px-0" v-show="modes.editView">
          <LmForm ref="lmFormBuilderRef" id="documentFormElements">
            <draggable
              class="col-12"
              v-model="form.formElements"
              @start="drag=true"
              @end="drag=false"
              >
              <div v-for="(formElement, index) in form.formElements" :key="formElement.id" class="mt-4 border border-primary">
                <header
                  class="d-flex justify-content-between align-items-center bg-primary text-white pr-3 pl-3"
                  :class="{'bg-info': !shouldCreatePortal(form.formElements[index].componentName)}">
                  <font-awesome-icon class="handle mr-4 bars" icon="bars" />
                  <h4 v-b-toggle="`collapse-${index}`" class="flex-grow-1 text-center">{{title(form.formElements[index])}}</h4>
                  <div v-if="shouldCreatePortal(form.formElements[index].componentName)" class="circle d-flex justify-content-center align-items-center">{{index}}</div>
                  <div>
                    <font-awesome-icon v-b-toggle="`collapse-${index}`" class="ml-4 clickable" icon="chevron-down" />
                    <font-awesome-icon class="ml-4 clickable" icon="trash" @click="removeFormElement(index)" />
                  </div>
                </header>
                <b-collapse
                  accordion="my-accordion"
                  :id="`collapse-${index}`"
                  visible
                  class="p-4"
                  >
                  <LmSelect
                    :id="'select-elements-' + index"
                    v-model="form.formElements[index].componentName"
                    :options="generator.selectorElementTypeOptions"
                    label="Seleccione el tipo de elemento"
                    @input="selectorElementForm($event, index)"
                  />
                  <component
                    :is="whatComponentBuilderUse(form.formElements[index].componentName)"
                    :id="form.formElements[index].formObjectToSendToServerProperty || form.formElements[index].id"
                    :componentData="form.formElements[index]"
                    :optionsChildOf="buildOptionsChildOf(form.formElements[index].formObjectToSendToServerProperty)"
                    :leftValueToCompareOptions="leftValueToCompareOptions(form.formElements[index])"
                    :visibilityDependOnConditions="form.formElements[index].visibilityDependOnConditions"
                    :optionsSameAsValidation="{content: buildSameAsOptions(form.formElements)}"
                    :validationsData="getValidation(form.formElements[index].formObjectToSendToServerProperty)"
                    :options="lmSuperPowerSelectV2BuilderUiOptions"
                    :isOnEditMode="isOnEditMode"
                    @input="inputHandler($event, index)"
                    @validations-changes="validationsChangesHandler"
                  />
                </b-collapse>
              </div>
            </draggable>
            <div class="col-12">
              <LmButton
                id="add-field-button"
                class="mt-4"
                type="button"
                lmButtonRootWrapperClass="d-inline-block"
                lmButtonWrapperClass="col"
                @click.native="addFormElement(form.formElements.length)"
                value="Agregar un campo"
              />
            </div>
          </LmForm>
        </div>
        <!-- Preview del formbuilder que se generará -->
        <div :class="{ 'col-md-6': modes.editView, 'col-12 px-0 mb-4': !modes.editView }">
          <LmFormBuilder
            :getComponents="form"
            :isOnPreviewMode="modes.editView"
            @openEditFormElement="openEditFormElement"
          />
        </div>
      </div>
    </div>
    <!-- FormBuilderUi -->
    <div class="d-flex wrapper-content pl-0">
      <LmButton
        class="col-auto pl-0"
        type="cancel"
        value="Cancelar"
        buttonClass="btn-secondary"
        id="cancelButton"
        @click.native="onCancel"
      />
      <LmButton
        :disabled="isDisabledByUserPrivileges()"
        class="col-auto"
        type="button"
        value="Guardar"
        buttonClass="btn-primary"
        id="saveButton"
        @click.native="onSubmit"
      />
      <LmButton
        v-if="editMode"
        class="col-auto"
        type="button"
        value="Eliminar"
        buttonClass="btn-danger"
        id="deleteButton"
        @click.native="onDelete"
      />
    </div>
    <p
      v-if="isDisabledByUserPrivileges()"
      class="font-italic text-danger"
    >
      Lo sentimos, no tiene permisos para guardar los cambios.
    </p>
  </div>
</template>

<script>
import {
  required
} from 'vuelidate/lib/validators'

import LmForm from '@/components/form/LmForm'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmButton from '@/components/form/elements/LmButton'
import LmSelect from '@/components/form/elements/LmSelect'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmSuperPowerSelectV2 from '@/components/form/elements/LmSuperPowerSelectV2'
import draggable from 'vuedraggable'
import VueScrollTo from 'vue-scrollto'
import LmFormBuilder from '@/components/LmFormBuilder'

import LmTextNumberEditorTextAreaPasswordBuilderUi from '@/components/lmFormBuilderUi/LmTextNumberEditorTextAreaPasswordBuilderUi'
import LmEmailInputBuilderUi from '@/components/lmFormBuilderUi/LmEmailInputBuilderUi'
import LmFormSubtitlesBuilderUi from '@/components/lmFormBuilderUi/LmFormSubtitlesBuilderUi'
import LmFormEmptySpaceBuilderUi from '@/components/lmFormBuilderUi/LmFormEmptySpaceBuilderUi'
import LmFormSeparatorBuilderUi from '@/components/lmFormBuilderUi/LmFormSeparatorBuilderUi'
import LmSelectBuilderUi from '@/components/lmFormBuilderUi/LmSelectBuilderUi'
import LmSuperPowerSelectV2BuilderUi from '@/components/lmFormBuilderUi/LmSuperPowerSelectV2BuilderUi'
import LmButtonBuilderUi from '@/components/lmFormBuilderUi/LmButtonBuilderUi'
import LmDateBuilderUi from '@/components/lmFormBuilderUi/LmDateBuilderUi'
import LmDateTimeBuilderUi from '@/components/lmFormBuilderUi/LmDateTimeBuilderUi'
import LmLeaFletMapBuilderUi from '@/components/lmFormBuilderUi/LmLeaFletMapBuilderUi'
import LmHtmlContentBuilderUi from '@/components/lmFormBuilderUi/LmHtmlContentBuilderUi'
import LmFormPortalBuilderUi from '@/components/lmFormBuilderUi/LmFormPortalBuilderUi'
import LmColorPickerBuilderUi from '@/components/lmFormBuilderUi/LmColorPickerBuilderUi'
import LmCommentBuilderUi from '@/components/lmFormBuilderUi/LmCommentBuilderUi'
import LmRepeatFieldsBuilderUi from '@/components/lmFormBuilderUi/LmRepeatFieldsBuilderUi'
import LmCheckboxBuilderUi from '@/components/lmFormBuilderUi/LmCheckboxBuilderUi'
import LmUploadFilesBuilderUi from '@/components/lmFormBuilderUi/LmUploadFilesBuilderUi'
import LmUserPermissions from '@/components/lmFormBuilderUi/LmUserPermissionsUi'

import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'
import lmFormBuilderUi from '@/mixins/lmFormBuilderUi.js'

import { checkUserPermissions } from '@/helpers/userPermissions'

export default {
  components: {
    LmForm,
    LmSuperPowerSelectV2,
    LmTextInput,
    LmCheckbox,
    LmButton,
    LmSelect,
    LmTextNumberEditorTextAreaPasswordBuilderUi,
    LmEmailInputBuilderUi,
    LmFormSubtitlesBuilderUi,
    LmFormEmptySpaceBuilderUi,
    LmFormSeparatorBuilderUi,
    LmSelectBuilderUi,
    LmSuperPowerSelectV2BuilderUi,
    LmButtonBuilderUi,
    LmDateBuilderUi,
    LmDateTimeBuilderUi,
    LmLeaFletMapBuilderUi,
    LmHtmlContentBuilderUi,
    LmFormPortalBuilderUi,
    LmColorPickerBuilderUi,
    draggable,
    LmCommentBuilderUi,
    LmRepeatFieldsBuilderUi,
    LmCheckboxBuilderUi,
    LmUploadFilesBuilderUi,
    LmUserPermissions,
    LmFormBuilder
  },
  mixins: [lmToasts, lmFormBuilderUi],
  data () {
    return {
      formData: {
        typeName: ''
      },
      form: {
        validations: {},
        formElements: [],
        allowAccess: [],
        allowCreate: [],
        allowUpdate: []
      },
      initialForm: {},
      modes: {
        selected: 'edit',
        options: [
          { text: '✏ Editar', value: 'edit' },
          { text: 'Preview 🥽', value: 'preview' }
        ],
        editView: true
      },
      visibilityDependOnIsChildCheckbox: false,
      loading: false,
      editMode: false,
      formPermissions: {
        allowAccess: process?.env?.VUE_APP_FORM_CODIFICATORBUILDER_ALLOW_PERMISSIONS.split(',') || [],
        allowCreate: process?.env?.VUE_APP_FORM_CODIFICATORBUILDER_CREATE_PERMISSIONS.split(',') || [],
        allowUpdate: process?.env?.VUE_APP_FORM_CODIFICATORBUILDER_UPDATE_PERMISSIONS.split(',') || []
      },
      userPrivileges: {},
      documentTypesOptionsForDuplicate: []
    }
  },
  validations: {
    formData: {
      typeName: {
        required
      }
    }
  },
  methods: {
    // updateForm (formDataFromLmFormBuilder) {
    //   for (const key in formDataFromLmFormBuilder) {
    //     this.formData[key] = formDataFromLmFormBuilder[key]
    //   }
    // },
    async onSubmit () {
      const documenttypeData = {
        ...this.formData,
        documentFields: [...this.form.formElements],
        documentFieldsValidations: this.form.validations,
        formPermissions: {
          allowAccess: this.form.allowAccess,
          allowCreate: this.form.allowCreate,
          allowUpdate: this.form.allowUpdate
        }
      }
      try {
        await this.validationForm(this.$v, false)
        this.loading = true
        if (this.editMode) {
          const r = await commonsApi.axiosPutWrapper(`/documenttypes/${this.$route.params.id}`, documenttypeData)
          this.lmToastSuccessMessage(`Se editó ${r?.data?.typeName || ' el tipo de documento'} correctamente.`, 'Se guardó exitosamente')
        } else {
          const r = await commonsApi.axiosPostWrapper(`/documenttypes/`, documenttypeData)
          this.lmToastSuccessMessage(`Se creó ${r?.data?.typeName || ' el tipo de documento'} correctamente.`, 'Se guardó exitosamente')
        }
        setTimeout(() => {
          this.loading = false
          this.$router.push(process.env.VUE_APP_DOCUMENT_TYPES_LISTBUILDER_PATH || '/listbuilder/view/6116c1efadd400578cd0e9e8')
        }, 650)
      } catch (error) {
        this.showToastFormError()
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async onDelete () {
      try {
        this.loading = true
        if (this.editMode) {
          await commonsApi.axiosPutWrapper(`/documenttypes/delete/${this.$route.params.id}`)
          setTimeout(() => {
            this.$router.push(process.env.VUE_APP_DOCUMENT_TYPES_LISTBUILDER_PATH || '/listbuilder/view/6116c1efadd400578cd0e9e8')
          }, 650)
        }
      } catch (error) {
        this.showToastFormError()
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    onCancel () {
      this.$router.push(process.env.VUE_APP_DOCUMENT_TYPES_LISTBUILDER_PATH || '/listbuilder/view/6116c1efadd400578cd0e9e8')
    },
    leftValueToCompareOptions (formElementToExclude) {
      return {
        disabledOption: this.$t('Element'),
        content: this.form.formElements.filter(e => e.hasOwnProperty('formObjectToSendToServerProperty')).filter(e => e.id !== formElementToExclude.id).map(e => ({ value: e.formObjectToSendToServerProperty, text: e.componentProps.label }))
      }
    },
    shouldCreatePortal (componentName) {
      return componentName !== 'LmComment'
    },
    openEditFormElement (index) {
      this.$root.$emit('bv::toggle::collapse', `collapse-${index}`)
    },
    title (component) {
      const componentLabel = component?.componentProps?.label
      const componentValue = component?.componentProps?.value
      const componentText = component?.componentProps?.text
      const { text } = this.generator.selectorElementTypeOptions.content.find(e => e.value === component?.componentName)
      let moreInfo = ''
      if (componentLabel) {
        moreInfo += ' - ' + componentLabel
      } else if (componentValue) {
        moreInfo += ' - ' + componentValue
      } else if (componentText) {
        moreInfo += ' - ' + componentText
      }
      return text + moreInfo
    },
    addFormElement (elementIndex) {
      this.selectorElementForm('LmTextInput', elementIndex)
    },
    inputHandler (event, index) {
      this.form.formElements[index] = event
    },
    validationsChangesHandler (payload) {
      let newValidation = {}
      const formValidationHasItem = Object.keys(this.form.validations).length
      if (formValidationHasItem) {
        for (const validation in this.form.validations) {
          const existFormObjectToSendToServerPropertyForValidation = this.form.formElements.find((el) => el.formObjectToSendToServerProperty === validation)
          if (existFormObjectToSendToServerPropertyForValidation) {
            newValidation = { ...newValidation, [validation]: this.form.validations[validation] }
          }
        }
        this.form.validations = { ...newValidation, ...payload }
      } else {
        this.form.validations = { ...this.form.validations, ...payload }
      }
    },
    showToastFormError (msg = this.$t('form_with_errors')) {
      this.$bvToast.toast(msg, {
        title: 'Error',
        toaster: 'b-toaster-bottom-center',
        variant: 'danger',
        solid: true
      })
    },
    errorScrollTo () {
      VueScrollTo.scrollTo(this.id, 1000, { offset: -60 })
    },
    validationForm (validation, mustShowToat = true) {
      validation.$touch()
      if (validation.$error) {
        if (mustShowToat) {
          this.showToastFormError()
        }
        this.errorScrollTo()
        return Promise.reject(new Error('validation error'))
      } else {
        if (!validation.$pending || !validation.$error) {
          return Promise.resolve(true)
        } else {
          Promise.reject(new Error('validation error'))
        }
      }
    },
    hideLoading () {
      this.loading = false
    },
    showLoading () {
      this.loading = true
    },
    async activeEditMode (getItemDetailObj, form = 'form') {
      try {
        this.isOnEditMode = true
        this.$emit('onEditMode', true)
        this.showLoading()
        const response = await commonsApi.getItemDetail({
          path: getItemDetailObj.path,
          id: getItemDetailObj.id,
          paramsMode: getItemDetailObj.paramsMode
        })
        this.$parent[form] = response
        this.hideLoading()
      } catch (error) {
        this.hideLoading()
        console.log('error: ', error)
        throw error
      }
    },
    isDisabledByUserPrivileges () {
      // Crear
      if (!this.userPrivileges.allowCreate && !this.editMode) {
        return true
      }
      // Actualizar
      if (!this.userPrivileges.allowUpdate && this.editMode) {
        return true
      }
      return false
    },
    async loadFormElements (event) {
      try {
        if (Array.isArray(event) && !event.length) {
          this.form.formElements = []
        } else {
          const documenttype = await commonsApi.axiosGetWrapper(`documenttypes/${event.id}`)
          const fields = documenttype.data.documentFields
          this.form.formElements = fields
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
  watch: {
  },
  async created () {
    // Set mode
    this.editMode = !!this.$route.params.id

    // Check user permissions
    this.userPrivileges = checkUserPermissions(this.formPermissions)
    if (!this.userPrivileges.allowAccess) {
      this.$router.push('/')
    }

    try {
      this.loading = true
      this.initialForm = JSON.stringify(this.form)

      if (this.editMode) {
        const { data } = await commonsApi.axiosGetWrapper(`documenttypes/${this.$route.params.id}`)
        this.formData = {
          typeName: data.typeName
        }
        this.form.formElements = data?.documentFields || []
        this.form.validations = data?.documentFieldsValidations || {}
        this.form.allowAccess = data?.formPermissions?.allowAccess || []
        this.form.allowCreate = data?.formPermissions?.allowCreate || []
        this.form.allowUpdate = data?.formPermissions?.allowUpdate || []

        if (!this.editMode) {
          this.showLoading()
          setTimeout(() => {
            this.$v.$reset()
            this.hideLoading()
          }, 350)
        }
        await this.$nextTick()
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.loading = false
    }
  },
  async mounted () {
    // Opciones para duplicar tipos de documento
    const documentTypes = await commonsApi.axiosGetWrapper('/documenttypes/?pageSize=100')
    const options = documentTypes.data.rows.map(doc => {
      return {
        id: doc._id,
        name: doc.typeName
      }
    })
    this.documentTypesOptionsForDuplicate = options
  },
  beforeDestroy () {
    this.$bvToast.hide('lm-toast-success-internal-link')
  }
}
</script>

<style lang="sass" scoped>
.circle
  background: white
  color: black
  border-radius: 50%
  width: 25px
  height: 25px
  text-align: center
</style>
